import React, { useState, useEffect } from 'react';

const ResultCard = ({ result, handleCardClick, isDragging, companyId }) => {
  // アコーディオン状態管理
  const [expanded, setExpanded] = useState(false);
  // モバイル判定
  const [isMobile, setIsMobile] = useState(false);
  // テキスト長判定
  const isShortText = result.title.length <= 11;

  // 画面サイズの変更を監視
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // 初期チェック
    checkIsMobile();
    
    // リサイズ時にチェック
    window.addEventListener('resize', checkIsMobile);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const handleClick = (e) => {
    // ドラッグ状態の安全なチェック
    const isDraggingActive = isDragging?.current && companyId && isDragging.current[companyId];
    
    // 短いテキストの場合は常に通常のナビゲーション
    if (isShortText) {
      if (!isDraggingActive) {
        handleCardClick(result);
      }
      return;
    }
    // PC表示時かつドラッグ中でない場合は通常のナビゲーション
    else if (!isDraggingActive) {
      handleCardClick(result);
    }
  };

  // 展開ボタンのクリックハンドラ
  const handleExpandClick = (e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const formatYearMonth = (dateString) => {
    // 不正な入力チェック
    if (!dateString) {
      return "無効な日付形式です";
    }
    
    try {
      let year, month;
      
      // ISO形式の日付文字列の場合 (例: "2021-12-01T00:00:00Z")
      if (dateString.includes('T') || dateString.includes('-')) {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          throw new Error("Invalid date");
        }
        year = date.getFullYear();
        month = String(date.getMonth() + 1).padStart(2, '0'); // 月は0ベースなので+1
      }
      // その他の形式
      else {
        throw new Error("Unsupported format");
      }
      
      // yyyy年MM月の形式で返す
      return `${year}年${month}月`;
      
    } catch (error) {
      return "無効な日付形式です";
    }
  }

    return (
    <div
      className={`result-card ${expanded ? 'expanded' : ''} ${isShortText ? 'short-text' : ''}`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(e); } }}
      style={{ cursor: 'pointer' }}
    >
      <div className="result-image-container">
        <ul className="result-card-left box">
          <li><h3>{result.classification}</h3></li>
          <li className={`goods-title ${isShortText ? 'short-text' : ''}`}>
            {result.productName}
            {isMobile && !isShortText && (
              <button
                className={`expand-button ${expanded ? 'expanded' : ''}`}
                onClick={handleExpandClick}
              />
            )}
          </li>
          <li className='goods-date'>{formatYearMonth(result.creationDate)}</li>
          <li>関連ページ：{result.pages ? `P.${result.pages}` : ''}</li>
        </ul>
        <div className='result-card-right'>
          <h3 className='result-card-right-title'>要約</h3>
          <p className='result-card-right-text'>{result.summary}</p>
        </div>
      </div>
    </div>
  );
};

export default ResultCard;